export default __webpack_public_path__ + "static/media/logo1.dbab9ae6.jpg";